module.exports = __webpack_public_path__ + "img/neotag_unit_orange-01.2dbfa997.svg";